import createIcon from '../../createIcon';

/**
 * @component @name BrunchDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4IDhIMjBWNEgxOFY4Wk0xNS41MSAyMkgyLjQ5QzIuMjIgMjIgMiAyMS43OCAyIDIxLjVWMjBIMTZWMjEuNUMxNiAyMS43OCAxNS43OCAyMiAxNS41MSAyMlpNMTggMTUuODlMMTcuNiAxNS40N0MxNi41OCAxNC4zOSAxNiAxMi45NSAxNiAxMS40N1YySDIyVjExLjUxQzIyIDEyLjk3IDIxLjQ2IDE0LjM4IDIwLjQ3IDE1LjQ1TDIwIDE1Ljk3VjIwSDIyVjIySDE4VjE1Ljg5Wk03IDE2VjE0SDExVjE2SDE1LjVDMTUuNzggMTYgMTYgMTYuMjIgMTYgMTYuNVYxNy41QzE2IDE3Ljc4IDE1Ljc4IDE4IDE1LjUgMThIMi41QzIuMjIgMTggMiAxNy43OCAyIDE3LjVWMTYuNUMyIDE2LjIyIDIuMjIgMTYgMi41IDE2SDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrunchDining = createIcon('BrunchDining', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18 8H20V4H18V8ZM15.51 22H2.49C2.22 22 2 21.78 2 21.5V20H16V21.5C16 21.78 15.78 22 15.51 22ZM18 15.89L17.6 15.47C16.58 14.39 16 12.95 16 11.47V2H22V11.51C22 12.97 21.46 14.38 20.47 15.45L20 15.97V20H22V22H18V15.89ZM7 16V14H11V16H15.5C15.78 16 16 16.22 16 16.5V17.5C16 17.78 15.78 18 15.5 18H2.5C2.22 18 2 17.78 2 17.5V16.5C2 16.22 2.22 16 2.5 16H7Z',
      key: '14dy1s',
    },
  ],
]);

export default BrunchDining;
